import { ApplicationService } from '../../services/application.service.js';
import { DebugService } from './debug.service.js';
import { REFI_VEHICLE_LOAN_CONST } from '../constants/app.constants.js';
import { ApiService } from '../../core/services/api/api.service.js';

export class _FeatureToggleService {
  constructor() {
    this.debug = new DebugService('FeatureToggleService');
    this.singleFeatureToggleResponse = null;
    this.multipleFeatureToggleResponse = null;
  }

  async getFeatureToggleStatus(featureKey, returnCached = true) {
    const url = REFI_VEHICLE_LOAN_CONST.GET_FEATURE_TOGGLE_URL(featureKey);
    try {
      if (
        this.singleFeatureToggleResponse &&
        returnCached &&
        this.singleFeatureToggleResponse[0].featureKey === featureKey
      ) {
        this.debug.log(
          'returning cached feature toggle status for key',
          featureKey
        );
        return this.singleFeatureToggleResponse[0].isEnabled;
      }
      const featureStatusResponse = await ApiService.get(url);
      this.singleFeatureToggleResponse = featureStatusResponse;
      this.updateStratumExperiments(featureStatusResponse);
      return featureStatusResponse[0].isEnabled;
    } catch (error) {
      this.debug.log('error getting feature toggle status', error);
    }
    return false;
  }

  async getMultipleFeatureToggleStatus(featureKeys, returnCached = true) {
    let url = REFI_VEHICLE_LOAN_CONST.GET_FEATURE_TOGGLE_URL('~');
    url = `${url}?featureKeys=${featureKeys}`;

    try {
      // this call return list of feature toggle status so the calling
      // function can check the status of each feature toggle
      if (this.multipleFeatureToggleResponse && returnCached) {
        // check if each key in comma separated featureKeys exists in cached response
        if (
          this.multipleFeatureToggleResponse.every((feature) =>
            featureKeys.includes(feature.featureKey)
          )
        ) {
          this.debug.log('returning cached list of feature toggle statuses');
          return this.multipleFeatureToggleResponse;
        }
      }
      const featureList = await ApiService.get(url);
      this.multipleFeatureToggleResponse = featureList;
      this.updateStratumExperiments(featureList);
      return featureList;
    } catch (error) {
      this.debug.log('error getting feature toggle status', error);
    }
    return null;
  }

  updateStratumExperiments(arrayOfFeatureObjects) {
    const newlyAddedFeatures = [];
    const removedFeatures = [];
    arrayOfFeatureObjects.forEach((featureObj) => {
      newlyAddedFeatures.push(
        featureObj.featureKey + (featureObj.isEnabled ? '-test' : '-bau')
      );
      removedFeatures.push(
        featureObj.featureKey + (featureObj.isEnabled ? '-bau' : '-test')
      );
    });
    ApplicationService.updateExperiments(newlyAddedFeatures, removedFeatures);
  }

  async updateIsInvisiblePQ() {
    if (ApplicationService.experiments?.includes('iconic-invisible-pq-only')) {
      ApplicationService.isInvisiblePQ = true;
    } else if (ApplicationService.experiments?.includes('iconic-test')) {
      const pqToggle = await this.getFeatureToggleStatus(
        REFI_VEHICLE_LOAN_CONST.FEATURE_TOGGLES.ICONIC_VL_FEATURE_TOGGLE
      );
      ApplicationService.isInvisiblePQ = pqToggle;
    } else {
      ApplicationService.isInvisiblePQ = false;
    }
  }

  // updateIsIconicAndToggledOn(inAppDeclineDelay) {
  //   if (inAppDeclineDelay) {
  //     ApplicationService.isIconicAndToggledOn = true;
  //   } else if (
  //     ApplicationService.experiments?.includes('iconic-invisible-pq-only')
  //   ) {
  //     ApplicationService.isIconicAndToggledOn = true;
  //   } else if (ApplicationService.experiments?.includes('iconic-test')) {
  //     ApplicationService.isIconicAndToggledOn = true;
  //     // quick patch before refactor - removed feature toggle async call due to not needing
  //     // await this.getFeatureToggleStatus(
  //     //   REFI_VEHICLE_LOAN_CONST.FEATURE_TOGGLES.ICONIC_VL_FEATURE_TOGGLE
  //     // );
  //   } else {
  //     ApplicationService.isIconicAndToggledOn = false;
  //   }
  // }
}

export const FeatureToggleService = new _FeatureToggleService();
